import { render, staticRenderFns } from "./DebtDetail.vue?vue&type=template&id=748bf502&scoped=true&"
import script from "./DebtDetail.vue?vue&type=script&lang=js&"
export * from "./DebtDetail.vue?vue&type=script&lang=js&"
import style0 from "./DebtDetail.vue?vue&type=style&index=0&id=748bf502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bf502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
